import InputStr from './InputStr';

export default InputStr;
